"use strict";

(function (global) {

  /**  
  * Фабрика сценариев.
  * Предоставлет инструменты для работы со сценариями, например, для выполнения сценария.
  *
  * @namespace WebAccess.factories.scripts
  * @property {OBJECT_TYPE} WebAccess.factories.scripts.contentType Тип содержимого фабрики
  * @since 5.0.0.7300
  */

  var Script = BaseObject.extend({
    className: "ScriptsFactory",

    contentType: OBJECT_TYPE.SCRIPT,
    name: '',
    parameters: {},

    init: function (scriptName) {
      if (!scriptName) {
        WA.raise('ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED', 'scriptName');
      };

      this.scriptName = scriptName;
      this._super(this.contentType);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Выполнить сценарий.
    *
    * @method WebAccess.factories.scripts.execute
    * @return {Object|WebAccess.components.dialogs.FormDialog} [opt_parameters] Параметры сценария или экземпляр диалога для копирования реквизитов диалога в параметры сценария.
    * @return {Deferred} Deferred-объект. 
    * @since 5.0.0.7300
    *
    * @example <caption>Выполнить сценарий и вывести его результат на консоль отладки.</caption>
    * WebAccess.factories.scripts("WADemoTest").execute({Note:'Примечание'}).done(function(data) { 
    *   //В data возвращается результат выполнения скрипта. 
    *   //Если этот результат является объектом IsBuilder, то он приводится к типу Models.Link. Примитивные типы остаются без изменений. 
    *   console.log(data)
    * });
    */
    execute: function (opt_parameters) {
      var me = this;
      me.parameters = opt_parameters || {};

      // Может расширить, сократить или переопределить поля модельки.
      var createRequestModel = function (model) {
        var requestModel = {};
        requestModel.webAccessClientClassName = (model) ? model.className:'';
        switch (requestModel.webAccessClientClassName) {
          case 'Link':
            $.extend(requestModel, {
              id: model.id,
              type: model.type,
              referenceName: model.referenceName || ""
            });
            break;
          case 'FormDialog':
            var dialog = me.parameters;
            $.extend(requestModel, dialog.form.serialize({
              onlyValue: true,
              useRowNumber: true,
              withoutTables: true,
              transformMultiReqsToDetailRows: true
            }));
            break;
          default:
            requestModel = model;
        }
        return requestModel;
      }

      if (me.parameters && me.parameters.className === 'FormDialog') {
        // Копируем реквизиты диалога в параметры сценария.
        var dialog = me.parameters;
        var serializedForm = createRequestModel(dialog);
        return WA.services.script.runWithSerializedForm(me.scriptName, serializedForm);
      }

      // Здесь моделька приобраетает вид, который мы сможем распознать на сервере
      // В поле webAccessClientClassName передается имя класса КОМ
      var requestParams = _.mapObject(me.parameters, function (value) {
        return createRequestModel(value);
      });

      return WA.services.script.run(me.scriptName, requestParams);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Выполнить сценарий с предварительным показом диалога.
    *
    * @method WebAccess.factories.scripts.showDialogAndExecute
    * @param {String} dialogName Имя диалога.
    * @return {Deferred} Результат выполнения сценария.
    * @since 5.0.0.1900
    *
    * @example <caption>Выполнить сценарий и вывести его результат на консоль отладки.</caption>
    * WebAcces.factories.scripts("WADemoTest").showDialogAndExecute('DialogName').done(function(data) { 
    *   console.log(data)
    * });
    */
    showDialogAndExecute: function (dialogName) {
      var me = this;
      var def = $.Deferred();
      if (dialogName) {
        // Отображение диалога.
        WA.FC.dialogs.getObjectByName(dialogName, MODEL.FULL).done(function (dialog) {
          dialog.show();
          dialog.bind(WA.CMP.dialogs.FormDialog.EVENT.AFTER_ACTION, function (dialogActionName, result) {
            if (dialogActionName === DIALOG_ACTION.OK) {
              me.execute(dialog).then(function (res) {
                def.resolve(res);
              });
            }
          });
        });
      } else {
        me.execute().then(function (res) {
          def.resolve(res);
        });
      }
      return def.promise();
    }
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.factories.scripts = function (scriptName) {
    return new Script(scriptName);
  };

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess);